import client from 'api/apiClient';
interface BasketEventTypes {
    name: string;
    description: string;
    goalAmount: number;
    type: string;
    subType: string;
    estimatedContributors: number;
    firstName: string;
    lastName: string;
    endDate: string;
    timeZone: string;
    currencyCode: string;
    companyId: number;
    nextPlannedStatusDate: string;
    nextPlannedStatus: string;
}

export const addNewBasketData = async (data: BasketEventTypes) => {
    const basketData = { ...data };
    try {
        const response = await client.post('/event', basketData);

        const data: any = response;
        return data;
    } catch (error) {
        console.error('Error getting data:', error);
        return error;
    }
};
